import SearchIcon from "@material-ui/icons/Search";
import EmailIcon from "@material-ui/icons/Email";
import CreateIcon from "@material-ui/icons/Create";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import SearchInput from "components/SearchInput";
import React, { useMemo, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import CustomModal from "components/CustomModal";
import styled from "styled-components";
import { currentColorSelector } from "views/Chat/selectors";
import { fetchListProjectGroup } from "actions/projectGroup/listProjectGroup";
import { useHistory } from "react-router-dom";
import CreateProjectGroup from "../CreateProjectGroup";
import {
  CREATE_PROJECT_GROUP,
  EDIT_PROJECT_GROUP,
  DELETE_PROJECT_GROUP,
  CustomEventDispose,
  CustomEventListener,
} from "constants/events";
import AlertModal from "components/AlertModal";
import nodata from "assets/ic_no_data_2021.png";
import { deleteProjectGroup } from "actions/projectGroup/deleteProjectGroup";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { apiService } from "constants/axiosInstance";

export const StyledDiv = styled.div`
  .line-option-selected {
    background: ${(props) => props.selectedColor}!important;
    color: #fff !important;
    border-radius: 3px;
  }
`;

const Row = (props) => {
  const classRow = props.isSelected ? "line-option-selected" : "";

  const handleSelect = () => {
    props.onSelect(props.group);
  };

  const editOfferGroup = (evt) => {
    evt.stopPropagation();
    props.handleOpenEditGroup(props.group);
  };
  const deleteOfferGroup = (evt) => {
    evt.stopPropagation();
    props.confimDeleteGroup(props.group);
  };
  console.log(props.group);
  return (
    <StyledDiv selectedColor={props.appColor}>
      <div
        className={`line-option per-line-modal ${classRow}`}
        onClick={handleSelect}
      >
        <div className="icon-option">
          {/* <img src={props.group.icon} /> */}
          <WorkspacesIcon
            sx={{
              color: "white !important",
              background: props.group?.color,
              padding: "5px",
              borderRadius: "6px",
            }}
          />
        </div>
        <div className="name-option">{props.group.name}</div>
        <div className="control-option">
          {props.group.can_modify && (
            <>
              <CreateIcon onClick={editOfferGroup} />
              <DeleteOutlineIcon
                onClick={deleteOfferGroup}
                style={{ marginRight: 13 }}
              />
            </>
          )}
          <ArrowForwardIosIcon
            onClick={(evt) => {
              evt.stopPropagation();
              props.handleNextGroup(props.group);
            }}
          />
        </div>
      </div>
    </StyledDiv>
  );
};

function SelectGroup({
  isOpen,
  setOpen,
  onSubmit = () => {},
  selectedOption = () => {},
  groupSelected,
}) {
  const timeoutRef = useRef(null);
  const history = useHistory();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const [groupOriginal, setGroupOriginal] = useState([]);
  const [groupProject, setGroupProject] = useState(groupOriginal);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [groupUpdate, setGroupUpdate] = useState(null);
  const [openAlertDelete, setOpenAlertDelete] = useState(false);
  const [groupDelete, setGroupDelete] = useState(null);

  const appColor = useSelector(currentColorSelector);

  function handleChangeSearch(evt) {
    setSearchValue(evt.target.value);
    const value = evt.target.value;
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      timeoutRef.current = null;
      let groupTemp = [];
      const cloneArr = JSON.parse(JSON.stringify(groupOriginal));
      cloneArr[currentIndex].data.map((e) => {
        if (
          String(e.name).toLowerCase().indexOf(String(value).toLowerCase()) >= 0
        ) {
          groupTemp.push(e);
        }
      });
      cloneArr[currentIndex].data = groupTemp;
      setGroupProject(cloneArr);
    }, 300);
  }

  const handleNextGroup = async (parentGroup) => {
    const config = {
      url: "/project-group/list",
      method: "get",
      params: {
        parent_group: parentGroup?.id,
      },
    };
    const response = await apiService(config);
    setCurrentIndex(currentIndex + 1);
    let tmp = JSON.parse(JSON.stringify(groupOriginal));
    tmp = tmp.concat({
      parent: parentGroup,
      data: response?.data?.project_groups ?? [],
    });
    setGroupOriginal(tmp);
    setGroupProject(tmp);
  };

  async function fetchListGroup() {
    try {
      if (isOpen) {
        const groupData = await fetchListProjectGroup();
        const tmp = [
          {
            parent: {
              name: "Nhóm làm việc",
              id: "",
            },
            data: groupData.data.project_groups,
          },
        ];
        setCurrentIndex(0);
        setGroupProject(tmp);
        setGroupOriginal(tmp);
      }
    } catch (e) {}
  }

  React.useEffect(() => {
    fetchListGroup();
  }, [isOpen]);

  React.useEffect(() => {
    CustomEventListener(CREATE_PROJECT_GROUP.SUCCESS, fetchListGroup);
    CustomEventListener(EDIT_PROJECT_GROUP.SUCCESS, fetchListGroup);
    CustomEventListener(DELETE_PROJECT_GROUP.SUCCESS, () => {
      fetchListGroup();
      if (groupDelete && groupSelected === groupDelete.id) {
        selectedOption(null);
      }
      setGroupDelete(null);
    });
    return () => {
      CustomEventDispose(CREATE_PROJECT_GROUP.SUCCESS, fetchListGroup);
      CustomEventListener(EDIT_PROJECT_GROUP.SUCCESS, fetchListGroup);
      CustomEventListener(DELETE_PROJECT_GROUP.SUCCESS, fetchListGroup);
    };
  }, []);

  function handleOpenCreateGroup() {
    setOpenModal(true);
    setGroupUpdate(null);
  }

  function handleOpenEditGroup(group) {
    setOpenModal(true);
    setGroupUpdate({
      id: group.id,
      name: group.name,
      description: group.description,
      icon: group.icon,
      sort_icon: group.short,
    });
  }

  function confimDeleteGroup(group) {
    setOpenAlertDelete(true);
    setGroupDelete(group);
  }
  const handleDeleteGroup = () => {
    dispatch(deleteProjectGroup({ projectGroupId: groupDelete.id }));
  };

  function handleSelect(group) {
    selectedOption(group);
    setOpen(false);
  }

  return (
    <>
      <CustomModal
        title={t("DMH.VIEW.PGP.MODAL.CUP.GROUPS")}
        open={isOpen}
        setOpen={setOpen}
        onCancle={() => {
          setOpen(false);
        }}
        height="tall"
        maxWidth="sm"
        actionLoading={loading}
        manualClose={true}
        canConfirm={true}
        className="custom-select-modal"
        confirmRender={null}
        cancleRender={() => t("IDS_WP_EXIT")}
      >
        <div className="body-head">
          <div className="per-line-modal">
            <SearchInput
              className={"custom-search"}
              placeholder={t("LABEL_SEARCH_PROJECT_GROUP")}
              value={searchValue}
              onChange={handleChangeSearch}
            />
          </div>
          <div className="per-line-modal tip-line">
            <b>{t("LABEL_TIP_IN_OFFER")}</b>
            <span>{t("LABEL_DESCRIPTION_TIP_IN_WORK_GROUP")}</span>
          </div>
          <div className="per-line-modal create-line">
            <span onClick={handleOpenCreateGroup} style={{ color: appColor }}>
              &#43; {t("CREATE_NEW_WORK_GROUP")}
            </span>
          </div>
        </div>
        <div className="body-main">
          <div style={{ display: "flex", alignItems: "center", minHeight: 45 }}>
            {currentIndex !== 0 ? (
              <ArrowBackIcon
                sx={{
                  margin: "0px 15px",
                  width: "30px",
                  height: "30px",
                  padding: "5px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  "&:hover": {
                    background: "#0000000a",
                  },
                }}
                onClick={() => {
                  setCurrentIndex(currentIndex - 1);
                  let tmp = JSON.parse(JSON.stringify(groupOriginal));
                  tmp.splice(tmp.length - 1, 1);
                  setGroupOriginal(tmp);
                  setGroupProject(tmp);
                }}
              />
            ) : (
              <div style={{ minWidth: 58 }} />
            )}
            <p style={{ margin: 0 }}>
              <b style={{ fontSize: 16 }}>
                {groupProject[currentIndex]?.parent?.name}
              </b>
            </p>
          </div>
          {groupProject[currentIndex]?.data.length ? (
            groupProject[currentIndex]?.data.map((e) => (
              <Row
                appColor={appColor}
                key={e.id}
                group={e}
                onSelect={handleSelect}
                isSelected={groupSelected === e.id ? true : false}
                handleOpenEditGroup={handleOpenEditGroup}
                confimDeleteGroup={confimDeleteGroup}
                handleNextGroup={handleNextGroup}
              />
            ))
          ) : (
            <div className="no-data-parent">
              <div className="no-data-selection">
                <img className="MuiAvatar-img" src={nodata} />
                <p>{t("LABEL_NO_DATA_SELECT_MODAL_PROJECT_GROUP")}</p>
                <p>{t("DESCRIPTION_NO_DATA_SELECT_MODAL_PROJECT_GROUP")}</p>
              </div>
            </div>
          )}
        </div>
      </CustomModal>
      {openModal && (
        <CreateProjectGroup
          open={true}
          setOpen={(value) => setOpenModal(value)}
          updatedProjectGroup={groupUpdate ? groupUpdate : null}
        />
      )}
      {openAlertDelete && (
        <AlertModal
          setOpen={(value) => setOpenAlertDelete(value)}
          onConfirm={() => handleDeleteGroup()}
          open={true}
          content={t("DMH.VIEW.PGP.LEFT.INFO.ALERT")}
        />
      )}
    </>
  );
}

export default SelectGroup;
